import React from 'react';
import moment from 'moment';


export default function DateDisplay({
                                        date,
                                        format = 'DD MMMM YYYY',
                                        className = 'tw-text-sm',
                                        emptyText = '-',
                                        emptyClassName = 'tw-text-gray-400',
                                    }) {
    if (!date) return <span className={`${className} ${emptyClassName}`}>{emptyText}</span>;
    return <span className={className}>{moment(date).format(format)}</span>;
}
